module.exports = __webpack_public_path__ + "static/media/Scenario-window.6a24b980.png";